<template>
  <div>
    <!--搜索条件-->
    <search-condition  @searchFtion="searchFtion" ref="searchConditionRef" @mask="maskClick"  @viewDetails="viewDetails"/>
    <div class="justify-content-between">
          <div class="itemcard" v-if="!noSearchResult">
              <ItemCard  :list="HotelList" @viewDetails="viewDetails" @addQuote="addQuote" @cancelQuote="cancelQuote"></ItemCard>
              <el-pagination layout="prev, pager, next " background class="w-100 mt-4  mb-4" 
                :total=Number(count) :current-page="formData.page"  @current-change="v => formData.page=v"
                :page-size="formData.num"/>
          </div>
          <!--没有搜索到结果提示-->
          <div class="itemcard" v-else>
            <div class="no-search-result">
              <img src="/images/order/icon_22.png"/>
              <div class="no-search-text">
                <p class="one">抱歉，没有搜索到相关结果。</p>
                <p class="two">请更改筛选选项后重试</p>
                <el-button type="primary" @click="clearSearch">清除选项</el-button>
              </div>
            </div>
          </div>
          <div class="right">
              <img src="/images/public/map2.jpg" class="map-img" @click="bookHotel()"/>
              <!--人气新增酒店-->
              <div class="popular-new-hotel">
                <ul class="popular-new-hotel-title">
                  <li v-for="item in hotelTagList" :key="item.id" :class="item.id==currentTab?'active':'default'"  @click="currentTab=item.id">
                    <div>{{item.name}}</div>
                  </li>
                </ul>
                <!--酒店列表-->
                <ul class="popularity-list">
                  <li v-for="(item,index) in currentTab=='1'?PopularHotelList:NewHotelList" :key="item.id" @click="viewDetails(item)">
                    <p :class="{'popularity-index':index==0}" class="label">
                      <img class="nem" src="/images/grade/hot.png" v-if="currentTab=='1'">
                      <img class="nem" src="/images/grade/new.png" v-else>
                    </p>
                    <div class="img-nrk">
                      <img v-lazy="ImgPreUrl+item.pic"   class="img-pic">
                    </div>
                    <div class="information">
                      <h3 class="title">
                        {{item.title| formatString(6)}}
                          <img v-lazy="'/images/zfxj/icon_'+item.state_star+'.png'" :key="item.state_star" height="16px" v-if="item.state_star>0"/>
                          <img v-lazy="'/images/xj/icon_'+item.star+'.png'" :key="item.star" height="16px" v-else />
                      </h3>
                      <div class="img-info">
                        <div class="star-text">{{item.star | formatVar('HotelStar')}}</div>
                      </div>
                      <div class="justify-content">
                        <div class="one">
                          <i class="iconfont icon-ruzhugongsi"></i>
                          <span>总客房</span>
                          <p>{{item.room_count}}</p>
                          <p>间</p>
                        </div>
                    </div>
                    </div>
                  </li>
                </ul>
              </div>      
          </div>
    </div>  
    <!--城市、搜索名称遮罩-->
     <div class="mask" v-if="maskIndex" @click="$refs.searchConditionRef.showCitySelection(false);"></div>
    <!--右侧浮动-二维码加询价清单-->
    <right-tab-bar></right-tab-bar>
  </div>
</template>

<script>
import {mapState, mapActions,mapGetters,mapMutations} from 'vuex';
import SearchCondition from './SearchCondition.vue';
import RightTabBar from '@/components/PublicComp/RightTabBar.vue';
import ItemCard from './ItemCard';
import { debounce } from "lodash";
export default {
  components: {
    SearchCondition,
    ItemCard,
    RightTabBar
  },
  props: {},
  data() {
    return {
      formData:{
        page:1,
        num:10,
      },
      //列表数量
      count:0,
      //酒店列表
      HotelList:[],
      //人气酒店列表
      PopularHotelList:[],
      //新增酒店列表
      NewHotelList:[],
      //当前tab选中
      currentTab:'1',
      //酒店标签
      hotelTagList:[{name:'人气酒店',id:'1'},{name:'新增酒店',id:'2'}],
      //遮罩层
      maskIndex:false,
      //筛选条件
      searchCon:{},
      //没有搜索到结果提示
      noSearchResult:false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
    watch:{
      'formData.page'() { this.HotelList=[]; this.getHotelList(this.searchCon); }
    },
  created() {},
  mounted() {
    this.$refs.searchConditionRef.initFilterFromRoute();
  },
  methods: {
    ...mapMutations(['UPDATEINQUIRYLISTINFO']),
    ...mapActions(['POST_HotelList']),
    searchFtion(searchCon){
      this.formData.page=1;
      this.noSearchResult=false;
      this.HotelList=[];
      this.searchCon={
        ...searchCon,
        city:searchCon.cityId,
        star:searchCon.star.join(','),
      }
      // 关键：push 到路由，保存筛选条件
      const params = {}
      Object.keys(this.searchCon).forEach(key => {
        const val = this.searchCon[key]
        if (
          val !== undefined &&
          val !== null &&
          val != false &&
          val !== '' &&
          (!Array.isArray(val) || val.length > 0)
        ) {
          params[key] = Array.isArray(val) ? val.join(',') : val
        }
      });
      console.log(params);
      this.$router.replace({
        path: this.$route.path,
        query:params
      }).catch(err => {});
      this.getHotelList(this.searchCon);
    },
    /*获取酒店/民宿列表*/
    getHotelList: debounce(async function(searchCon){
      // let top = document.documentElement.scrollTop || document.body.scrollTop;
      //   // 实现滚动效果
      //   const timeTop = setInterval(() => {
      //     document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      //     if (top <= 400) {
      //       clearInterval(timeTop)
      //     }
      // })
      let res=await this.POST_HotelList({data: {...this.formData,...searchCon}});
       window.scrollTo(0, 0);
      //没有搜索到结果
      if(this.formData.page==1&&res.data.count==0){
        this.noSearchResult=true;
      }
      let dada=res.data;
      this.HotelList=dada.list;
      this.count=dada.count;
      this.PopularHotelList=dada.hotelRightHot;
      this.NewHotelList=dada.hotelRightNew;
    },500),
    //开始或关闭遮罩
    maskClick(index){
      this.maskIndex=index;
      if(index){
        document.body.style.overflow = 'hidden';
      }else{
        document.body.style.overflow = '';
      };
      
    },
    //酒店地图
    bookHotel() {
      // if (!this.$GFUN.powerIsInArray([226])) { this._alert('您没有相关权限！',null,'error'); return; }
      if(!this.userInfo.type){
      this.$alert('请先登录账号，再查找酒店', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: () => {
            this.$router.push('/userLogin');
          }
        });
        return
      };
      this.$router.push({name: 'hotelMapSearch'});
    },
    //清除选项
    clearSearch(){
      this.$refs.searchConditionRef.formData(1);
    },
    //加入询价
    addQuote(item){
      this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'add'});
      this.$message.success('添加成功！')
    },
    //取消询价
    cancelQuote(item){
      console.log(item,取消);
      this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'deletes'});
      this.$message.success('取消成功！')
    },
    //查看详情
    viewDetails(item){
      console.log(item);
        let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.id);
        window.open(changeRoute.href, '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
  .justify-content-between{
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .itemcard{
    width: 70%;
  }
  .right{
    width: 27%;
    cursor: pointer;
  }
  .map-img{
    width: 100%;
    border-radius: 16px;  
    box-shadow: 0px 0px 7px #eee;
    transition: all 0.3s ease;
    border: 4px #fff solid;
    height: 202px;
  }
  .map-img:hover{
    box-shadow: 0px 0px 10px #ccc;
  }
  .popular-new-hotel{
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
    margin-top: 16px;
    box-shadow: 0px 0px 7px #eee;
    overflow: hidden;
  }
  .popular-new-hotel-title{
    display: flex;
    text-align: center;
    background-color: #f1f2f4;
    border: 2px #fff solid;
    border-bottom: none;
    li{
      width: 50%;
      line-height: 40px;
      background-color: #fff;
      color: #999;

    }
  }
  .popular-new-hotel-title .active:nth-child(1){
    background-color: #f1f2f4;
  }
  .popular-new-hotel-title .active:nth-child(2){
    background-color: #f1f2f4;
  }
  .popular-new-hotel-title .active:nth-child(1) div{
    border-radius: 0 20px 0 0;
    background-color: #fff;
  }
  .popular-new-hotel-title .default:nth-child(1) div{
    border-radius: 0 0 20px 0;
    background-color: #f1f2f4;
  }
  .popular-new-hotel-title .default:nth-child(2) div{
    border-radius:  0 0 0 20px;
    background-color: #f1f2f4;
  }
  .popular-new-hotel-title .active:nth-child(2) div{
    border-radius: 20px 0 0 0;
    background-color: #fff;
  }
  // .popular-new-hotel-title .active{
  //   background-color: #f1f2f4;
  //   color: var(--smtc-color-primary);
  //   font-weight: bold;
  //   div:nth-child(1){
  //       background-color: #fff;
  //       border-radius: 20px 0  0 0;
  //   }
  // }
  .popularity-list{
    width: 100%;
    overflow: hidden;
    box-shadow: 0px 0px 7px #eee;
  }
  .popularity-list li{
    display: flex;
    padding: 12px 0;
    border-bottom: 1px #eee solid;
    cursor: pointer;
  }
  .popularity-list li:hover{
    background-color: #f9fafb;
  }
  .popularity-list li .label{
    // background-color: #e5e7eb;
    color: #999;
    display: block;
    border-radius: 50px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    font-size: 14px;
    margin: 26px 10px;
  }
   .popularity-list li .img-pic{
    width: 80px;
    height: 80px;
    transition: transform 0.25s ease;
   }
  .popularity-list li .img-pic:hover{
    transform: scale(1.1);
  }
  .popularity-list li .img-nrk{
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 16px;
    margin-right: 10px;
  }
  .information{
    text-align: left;
    width: 58%;
    .title{
      margin-top: 4px;
    }
  }
  .title{
    font-size: 14px;
  }
  .mask{
    position: fixed;
    width: 100%;
    background: rgba(0, 0, 0, .6);
    height: 90vh;
    left: 0;
    top: 170px;
    z-index: 6 ;
  }
  // .popularity-list li .popularity-index{
  //   background-color: #12b2cb;
  //   color: #fff;
  // }
  .no-search-result{
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 7px #eee;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    padding: 52px 0;
    img{
      width: 120px;
    }  
  }
  .no-search-text{
    margin-left: 14px;
    text-align: left;
    .one{
      font-weight: bold;
      font-size: 16px;
    }
    .two{
      color: #666;
      margin: 6px 0;
    }
  }
  .img-info{
    display: flex;
    img{
      margin-top: 4px;
      margin-right: 8px;
    }
  }
  .star-text{
    // background-color: #eff6ff;
    // color: #12b2cb;
    padding: 4px 6px;
    font-size: 10px;
    border-radius: 4px;
    margin-top: 3px;
  }
  .nem{
    width: 20px;
    height: 20px;
    margin-left: 4px;
    margin-top: 4px;
  }
  .justify-content{
    display: flex;
    margin-top: 4px;
    div{
      background-color: #f9fafb ;
      padding: 0 10px;
      display: flex;
      border-radius: 6px;
      font-size: 12px;
      line-height: 30px;
      color: #4a5565;
      i{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-right: 4px;
        color: #99a1af;
        font-size: 15px;
      }
    }
  }
  .justify-content .one p{  
    font-weight: bold;
    color: #333;
    margin-left: 4px;
  }
</style>
<style>
  .justify-content-between .el-pager li:last-child{
    display: none;
  }

</style>
